module.exports = __webpack_public_path__ + "imgascvts/logo_ass01.6b573f0d.png";